var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGroup = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.3 196.8C168.9 196.8 166.2 194.1 166.2 190.7V178.6C166.2 168.6 158 160.4 148 160.4H99.6C89.6 160.4 81.4 168.6 81.4 178.6V190.7C81.4 194.1 78.7 196.8 75.3 196.8C71.9 196.8 69.2 194.1 69.2 190.7V178.6C69.2 161.9 82.8 148.3 99.5 148.3H148C164.7 148.3 178.3 161.9 178.3 178.6V190.7C178.4 194.1 175.7 196.8 172.3 196.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.8 136.2C107.1 136.2 93.5 122.6 93.5 105.9C93.5 89.2 107.1 75.6 123.8 75.6C140.5 75.6 154.1 89.2 154.1 105.9C154.1 122.6 140.5 136.2 123.8 136.2ZM123.8 87.7C113.8 87.7 105.6 95.9 105.6 105.9C105.6 115.9 113.8 124.1 123.8 124.1C133.8 124.1 142 115.9 142 105.9C142 95.9 133.8 87.7 123.8 87.7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208.7 196.8C205.3 196.8 202.6 194.1 202.6 190.7V178.6C202.6 170.3 197 163.1 189 161C185.8 160.2 183.8 156.9 184.6 153.6C185.4 150.3 188.7 148.4 192 149.2C205.4 152.7 214.7 164.7 214.7 178.5V190.6C214.7 194.1 212 196.8 208.7 196.8Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.2 135.4C163.5 135.4 161 133.6 160.3 130.8C159.5 127.6 161.4 124.3 164.7 123.4C171.1 121.8 176.2 116.7 177.8 110.3C180.3 100.6 174.4 90.7 164.7 88.2C161.5 87.4 159.5 84.1 160.3 80.8C161.1 77.6 164.4 75.6 167.7 76.4C183.9 80.5 193.7 97.1 189.5 113.3C186.8 124 178.4 132.4 167.7 135.1C167.2 135.4 166.7 135.4 166.2 135.4Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/group.839ad9a9.svg";
export { ForwardRef as ReactComponent };